module.exports = __webpack_public_path__ + "static/img/30014 (4).0cdb574.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30014 (4).webp
// module id = aArM
// module chunks = 14